import { render, staticRenderFns } from "./treeselect.vue?vue&type=template&id=213badce&scoped=true&"
import script from "./treeselect.vue?vue&type=script&lang=ts&"
export * from "./treeselect.vue?vue&type=script&lang=ts&"
import style0 from "./treeselect.vue?vue&type=style&index=0&id=213badce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213badce",
  null
  
)

export default component.exports